import { makeStyles } from '@material-ui/core/styles'

import SparkleIcon from './sparkle-icon'

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 800,
    fontSize: '3rem',
    lineHeight: 1,
    color: '#1f3368',
    letterSpacing: '-0.02em',
  },
  sparkle: {
    position: 'absolute',
    left: '100%',
    width: '0.58em',
    height: '0.58em',
    color: '#f47d6b',
    transform: 'translateY(-80%)',
  },
}))

const AppLogo = () => {
  const classes = useStyles()

  return (
    <span className={classes.root}>
      Max
      <span className={classes.sparkle}>
        <SparkleIcon />
      </span>
    </span>
  )
}

export default AppLogo
